module.exports = __webpack_public_path__ + "img/hyal-6@2x.3812831b.png";